export default{
  inserted(el, binding, vnode) {
    const { value } = binding
    // 自定义指令的执行函数，，取到登录缓存的按钮权限数组，赋值给全局对象userMsg
    global.ButtonPermissions = JSON.parse(localStorage.getItem('ButtonPermissions'))
    if (global.ButtonPermissions && global.ButtonPermissions.indexOf(value) < 0) {
      el.style.display = 'none'
    }
  }
}


// WEBPACK FOOTER //
// ./src/directive/permission/permission.js